export enum LogViewerTableRowType {
  LogEntry,
  Summary,
  FileDivider,
}

export interface LogViewerTableRowModel {
  delegate?: LogViewerTableRowModelDelegate;
  data: LogViewerTableRowModelData;
}

export interface LogViewerTableRowModelData {
  type: LogViewerTableRowType;

  indexBeforeApplyingFilters: number;
  indexAfterApplyingFilters: number | undefined;

  passesFilter: boolean;
  isSelected: boolean;
  isBookmarked: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- it's ok
export interface LogViewerTableRowCellModelData {}

export interface LogViewerTableRowModelDataWithCells {
  rowData: LogViewerTableRowModelData;
  allCells: LogViewerTableRowCellModelData[];
}

export interface LogViewerTableRowModelDelegate {
  onRequestRedraw(rowModel: LogViewerTableRowModel): void;
  onRequestScrollToRow(rowModel: LogViewerTableRowModel): void;

  onRequestAddToBookmarks(rowModel: LogViewerTableRowModel): void;
  onRequestDeleteFromBookmarks(rowModel: LogViewerTableRowModel): void;
}
